import { Component, OnInit } from '@angular/core';
import { FacadeService } from './services/FacadeService';
import { MatDialog } from '@angular/material/dialog';
import {LoginDialogComponent} from './components/login-dialog/login-dialog.component';
import {RegistrationDialogComponent} from './components/registration-dialog/registration-dialog.component';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { logout} from './store/user/user.action';
import {User} from 'src/models';
import { ResetPasswordDialogComponent } from './components/reset-password-dialog/reset-password-dialog.component';
import { MessageService } from './services/MessageService';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent implements OnInit{
  count$: Observable<number>;
  count: number;
  sideMenuOpen: boolean;
  currentYear: number;

  user$: Observable<User>;
  user: User;
  


  constructor(private service: FacadeService, private dialog: MatDialog, private store: Store<{user: User}>, private messageService: MessageService){}

  ngOnInit(): void {
    this.user = new User();
    this.sideMenuOpen = false;
    this.currentYear = new Date().getFullYear();
    this.user$ = this.store.select('user');
    this.user$.subscribe(x => {
      this.user = x;

      if(x.resetPassword) {
        this.dialog.open(ResetPasswordDialogComponent, {autoFocus: false, position: { top: '10px' }, disableClose: true});    
      } else if(x.isLoggedIn) {
        this.service.productService.VerifyAuth();
      }
    });
  }

  onLogin() {    
    const dialogRef = this.dialog.open(LoginDialogComponent, {autoFocus: false, position: { top: '10px' }});    
    this.sideMenuOpen = false;
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.register) {
       this.onRegister();
      }
    });
  }

  onLogout() {
    this.service.productService.Logout().then(() => {
      this.store.dispatch(logout());
      this.sideMenuOpen = false;
    });    
  }

  onRegister() {
    this.dialog.open(RegistrationDialogComponent, {autoFocus: false, position: { top: '10px' }});    
    this.sideMenuOpen = false;
  }

  openSideMenu() {
    this.sideMenuOpen = true;
 }

 closeSideMenu() {
    this.sideMenuOpen = false;
 }

 contenBodyClick(e)  {   
   e.stopPropagation();
 }

 onProjectSearchLaunch() {      
   this.messageService.sendMessage('Launch Project Search');
   this.sideMenuOpen = false;
 }

}
